var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.active_toggle_btn_class,attrs:{"id":"nav-icon3"},on:{"click":_vm.toggle_menu}},[_c('span'),_c('span'),_c('span'),_c('span')])}
var staticRenderFns = []

export { render, staticRenderFns }